import React from "react";
import { Text } from "@networkraildigitalfactory/components";
import { CircleGo } from "../TableIcons/TableIcons";
import styles from "./PageTitle.module.css";

const PageTitle = (props) => {
  const {
    titleHeader,
    titleParagraph,
    startReviewPrep,
    buttonText,
    children,
    isCustom,
    hideButton,
    enableSkip = false,
  } = props;

  const renderPageTitle = () => {
    if (isCustom) {
      return children;
    }
    return (
      <>
        <Text
          className={styles.title_header}
          type="header"
          wrapper="h2"
          style={{
            fontWeight: "800",
            fontSize: "32px",
            lineHeight: "140%",
            color: "#37519D",
          }}
        >
          {titleHeader}
        </Text>
        <Text
          className={styles.title_paragraph}
          type="body"
          wrapper="p"
          size="16px"
          style={{
            fontWeight: "500",
            fontSize: "16px",
            lineHeight: "118%",
            color: "#37519D",
            letterspacing: "0.0015em",
          }}
        >
          {titleParagraph}
        </Text>

        <div className={styles.bottom_row}>
          {!hideButton && (
            <button
              id={enableSkip ? "tabToMe" : ""}
              onClick={startReviewPrep}
              type="button"
              className={styles.button_group}
              name={buttonText}
            >
              <Text
                type="body"
                wrapper="p"
                size="16px"
                style={{
                  fontWeight: "800",
                  fontSize: "24px",
                  lineHeight: "140%",
                  color: "#37519D",
                  letterspacing: "0.0015em",
                  marginTop: "0px",
                }}
              >
                {buttonText}
              </Text>
              <div role="button" aria-label={buttonText} className={styles.icon_right}>
                <CircleGo />
              </div>
            </button>
          )}
        </div>
      </>
    );
  };

  return (
    <div className={styles.title_background}>
      <div className={styles.internal}>{renderPageTitle()}</div>
    </div>
  );
};

export default PageTitle;
